import { ThemeOptions } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

import { colors } from './colors';
import { components } from './components';
import { typography } from './typography';

export const timeLogThemeOptions: ThemeOptions = {
  spacing: parseInt(scssVariables.SpacingUnit, 10),
  palette: {
    error: {
      main: scssVariables.ColorError80Hex,
      light: scssVariables.ColorError10Hex,
      dark: scssVariables.ColorError100Hex,
      // contrastText: scssVariables.ColorWhite,
    },
    success: {
      main: scssVariables.ColorSuccess80Hex,
      light: scssVariables.ColorSuccess10Hex,
      dark: scssVariables.ColorSuccess100Hex,
    },
    warning: {
      main: scssVariables.ColorWarning80Hex,
      light: scssVariables.ColorWarning10Hex,
      dark: scssVariables.ColorWarning100Hex,
    },
    info: {
      main: scssVariables.ColorInfo80Hex,
      light: scssVariables.ColorInfo10Hex,
      dark: scssVariables.ColorInfo100Hex,
    },
    // primary: {},
    // secondary: {
    //   main: '#E5E7F1',
    //   contrastText: '#313131',
    // },
  },
  // TODO: revisit this, feels a bit senseless to have the same CSS variables twice
  colors: colors,
  typography: typography,
  components: components,
};
